import { useState, useEffect } from "react";
import { useMutation, useQuery } from "convex/react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {api} from "./convex/_generated/api"
//import Loader from "../components/Loader";
import { useLocation,useNavigate } from "react-router-dom";
import axios from "axios";

const SKILL_LEVELS = ["beginner", "intermediate", "advanced"];

export default function Profile() {
  const location = useLocation();
  const sessionId =
    location.state?.sessionId || localStorage.getItem("session_id");
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Get user from session
  const user = useQuery(
    api.users.getUserBySession,
    sessionId ? { sessionId } : "skip"
  );

  //console.log(user);

  // FIX: user.userId doesn't exist - a Convex document's id field is
  // _id. This was silently sending userId: undefined to the query.
  const savings = useQuery(
    api.wasteSavings.getWeeklySavings,
    user ? { userId: user._id } : "skip"
  );

  //console.log(savings);

  // FIX: api.users.insertTravelNotice doesn't exist anywhere in the
  // backend - this crashed on mount, before anything even rendered.
  // It was also never called anywhere in this file (handleSave only
  // does the axios call below), so removing it changes no behavior.

  const [demoKey, setDemoKey] = useState(
    localStorage.getItem("demoKey") || ""
  );

  const [username, setUsername] = useState(user?.fullName || "");
  const [dietaryRestriction, setDietaryRestriction] = useState(
    user?.dietaryRestriction || ""
  );
  const [householdSize, setHouseholdSize] = useState(
    user?.householdSize || 1
  );
  const [weeklyBudget, setWeeklyBudget] = useState(
    user?.weeklyBudget || 100
  );
  const [skillLevel, setSkillLevel] = useState(
    user?.skillLevel || "beginner"
  );
  const [cuisineType, setCuisineType] = useState(
    user?.cuisineType || ""
  );
  const [saved, setSaved] = useState(false);

  // FIX: the useState(user?.field || "") initializers only run once,
  // on the very first render - while user is still undefined (the
  // session query hasn't resolved yet). So every field would lock in
  // its empty/default fallback and never update once the real user
  // document arrived a moment later. This syncs the form in once user
  // actually loads.
  //useEffect(() => {
    //if (!user) return;
    //setUsername(user.username || "");
    //setDietaryRestriction(user.dietaryRestriction || "");
    //setHouseholdSize(user.householdSize || 1);
    //setWeeklyBudget(user.weeklyBudget || 100);
    //setSkillLevel(user.skillLevel || "beginner");
    //setCuisineType(user.cuisineType || "");
  //}, [user]);

  async function handleSave() {
  try {
    const res = await axios.post(
      "https://mealplan-backend-dzss.onrender.com/api/meals",
      {
        // FIX: user.userId doesn't exist - was sending userId: undefined.
        userId: user._id,
        username,
        householdSize,
        dietaryNeeds: dietaryRestriction,
        weeklyBudget,
        skillLevel,
        cuisineType,
        cookTime: 30
      }
    );

    //console.log("Meal plan generated:", res.data);
    navigate("/mealplan", {
  state: {
    sessionId,
  },
});

    setSaved(true);

    setTimeout(() => {
      setSaved(false);
    }, 2000);

  } catch (err) {
    console.error(
      "Recipe generation failed:",
      err.response?.data || err.message
    );
  }
}

  function handleSignOut() {
    localStorage.removeItem("session_id");
    navigate("/");
  }

  //if (user === undefined) {
    //return <Loader />;
  //}
  //      {savings === undefined && <Loader />}


  const sidebarLinks = [
    { label: "Meal Plan", path: "/mealplan", state: { sessionId } },
    { label: "Grocery List", path: `/grocery/${user?._id ?? ""}` },
    { label: "Pantry", path: `/pantry/${user?._id ?? ""}` },
    { label: "Waste Dashboard", path: `/wastedashboard/${user?._id ?? ""}` },
    { label: "Profile", path: "/profile", state: { sessionId } },
  ];

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>

      {sidebarOpen && (
        <aside
          style={{
            width: 200,
            flexShrink: 0,
            background: "#1c1c1c",
            borderRight: "1px solid #2a2a2a",
            padding: "24px 16px",
            position: "sticky",
            top: 0,
            height: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 24,
            }}
          >
            <div
              style={{
                color: "#00e676",
                fontWeight: 700,
                fontSize: 13,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
              }}
            >
              MealPilot
            </div>

            <button
              onClick={() => setSidebarOpen(false)}
              aria-label="Close menu"
              style={{
                background: "transparent",
                border: "none",
                color: "#9a9a95",
                fontSize: 18,
                cursor: "pointer",
                lineHeight: 1,
                padding: 4,
              }}
            >
              ✕
            </button>
          </div>

          <nav style={{ display: "flex", flexDirection: "column", gap: 4, flex: 1 }}>
            {sidebarLinks.map((link) => (
              <button
                key={link.label}
                onClick={() =>
                  navigate(link.path, link.state ? { state: link.state } : undefined)
                }
                style={{
                  textAlign: "left",
                  background: "transparent",
                  border: "none",
                  color: "#f4f4f2",
                  padding: "10px 12px",
                  borderRadius: 8,
                  cursor: "pointer",
                  fontSize: 14,
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#2a2a2a")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                {link.label}
              </button>
            ))}
          </nav>

          <button
            onClick={handleSignOut}
            style={{
              textAlign: "left",
              background: "transparent",
              border: "1px solid #2a2a2a",
              color: "#ff6b6b",
              padding: "10px 12px",
              borderRadius: 8,
              cursor: "pointer",
              fontSize: 14,
              marginTop: 12,
            }}
          >
            Sign out
          </button>
        </aside>
      )}

      {!sidebarOpen && (
        <button
          onClick={() => setSidebarOpen(true)}
          aria-label="Open menu"
          style={{
            position: "fixed",
            top: 1,
            left: 1,
            background: "#1c1c1c",
            border: "1px solid #2a2a2a",
            color: "#f4f4f2",
            borderRadius: 8,
            padding: "8px 12px",
            cursor: "pointer",
            fontSize: 16,
            zIndex: 10,
          }}
        >
          ☰
        </button>
      )}

      <div className="screen" style={{ flex: 1 }}>
        <div className="eyebrow" style={{ marginLeft: 40 }}>Impact</div>
        <h1 className="page-title"  style={{ marginTop: 20 }}>Your waste savings</h1>


        {savings && (
          <>
            <div
              className="ticket"
              style={{
                background: "var(--accent-dim)",
                borderColor: "var(--accent)",
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontFamily: "var(--font-mono)",
                  fontSize: 13,
                  color: "var(--accent)",
                }}
              >
                🔥 {savings?.streak}{" "}
                {savings?.streak === 1 ? "week" : "weeks"} of zero waste!
              </p>
            </div>

            <div className="stat-grid" style={{ marginTop: 16 }}>
              <div className="stat-box">
                <div className="stat-value">
                  ${savings?.savedAmount?.toFixed(0) || "0.0"}
                </div>
                <div className="stat-label">Total money saved</div>
              </div>

              <div className="stat-box">
                <div className="stat-value">{savings?.totalMealsCooked}</div>
                <div className="stat-label">
                  Meals cooked from what you had
                </div>
              </div>
            </div>

            {savings?.series?.length > 0 && (
              <div
                className="ticket"
                style={{ height: 220, marginBottom: 24 }}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={savings?.series}>
                    <CartesianGrid stroke="#2a2a2a" />
                    <XAxis
                      dataKey="label"
                      stroke="#9a9a95"
                      fontSize={12}
                    />
                    <YAxis stroke="#9a9a95" fontSize={12} />
                    <Tooltip
                      contentStyle={{
                        background: "#1c1c1c",
                        border: "1px solid #2a2a2a",
                      }}
                      labelStyle={{ color: "#f4f4f2" }}
                    />
                    <Line
                      type="monotone"
                      dataKey="moneySaved"
                      stroke="#00e676"
                      strokeWidth={2}
                      dot={false}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            )}
          </>
        )}

        <div className="eyebrow" style={{ marginTop: 8 }}>
          Profile
        </div>
        <h1 className="page-title">Your preferences</h1>

        <div className="field">
          <label>Display name</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="field">
          <label>Dietary restriction</label>
          <input
            type="text"
            value={dietaryRestriction}
            onChange={(e) => setDietaryRestriction(e.target.value)}
          />
        </div>

        <div className="field">
          <label>Household size</label>
          <input
            type="number"
            value={householdSize}
            onChange={(e) => setHouseholdSize(Number(e.target.value))}
          />
        </div>

        <div className="field">
          <label>Weekly budget: ${weeklyBudget}</label>
          <input
            type="range"
            min={30}
            max={200}
            step={5}
            value={weeklyBudget}
            onChange={(e) => setWeeklyBudget(Number(e.target.value))}
          />
        </div>

        <div className="field">
          <label>Skill level</label>
          <select
            value={skillLevel}
            onChange={(e) => setSkillLevel(e.target.value)}
          >
            {SKILL_LEVELS.map((s) => (
              <option key={s} value={s}>
                {s[0].toUpperCase() + s.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div className="field">
          <label>Preferred cuisine</label>
          <input
            type="text"
            value={cuisineType}
            onChange={(e) => setCuisineType(e.target.value)}
          />
        </div>

        <button className="btn btn-primary" onClick={handleSave}>
          {saved ? "Saved!" : "Save changes"}
        </button>
      </div>

    </div>
  );
}
